var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8573_156309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8573_156309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21212 13.4545C3.21212 10.7811 5.38727 8.60598 8.0606 8.60598C10.7339 8.60598 12.9091 10.7811 12.9091 13.4545H3.21212ZM6.24242 5.57567V4.36355C6.24242 3.36113 7.05818 2.54537 8.0606 2.54537C9.06303 2.54537 9.87879 3.36113 9.87879 4.36355V5.57567C9.87879 6.5781 9.06303 7.39386 8.0606 7.39386C7.05818 7.39386 6.24242 6.5781 6.24242 5.57567ZM10.143 7.7684C10.7242 7.21689 11.0909 6.44113 11.0909 5.57568V4.36355C11.0909 2.69022 9.73455 1.33325 8.06061 1.33325C6.38667 1.33325 5.0303 2.69022 5.0303 4.36355V5.57568C5.0303 6.44113 5.39697 7.21689 5.97818 7.76901C3.65879 8.61871 2 10.8399 2 13.4545V14.0605C2 14.3939 2.27273 14.6666 2.60606 14.6666H13.5152C13.8485 14.6666 14.1212 14.3939 14.1212 14.0605V13.4545C14.1212 10.8399 12.463 8.61871 10.143 7.7684Z",
    fill: "#005EB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.27b28b65e6ffe6656bc033308e3c6bbd.svg";
export { ForwardRef as ReactComponent };